import React, { FC } from "react";
import { useParams } from "react-router-dom";

import { RecommendationDetail } from "@components/main/recommendation";

const RecomendationPage: FC = () => {
  const { recommendationId } = useParams();

  return <RecommendationDetail recommendationId={recommendationId} />;
};

export default RecomendationPage;
